export default __webpack_public_path__ + "static/media/SideNav.603f78fb.svg";